export class SearchCondition {
  created_at_from: string = ""
  created_at_to: string = ""
  file_name: string = ""
  title: string = ""
  user_id: string = ""
}

export class StudentFileUpload {
  id: number
  user_id: number
  user_name: string
  file_name: string
  title: string
  comment: string
  created_at: string
  file_count: number
  is_delete_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.user_id = x.user_id;
    this.user_name = x.user_name;
    this.file_name = x.file_name;
    this.title = x.title;
    this.comment = x.comment;
    this.created_at = x.created_at;
    this.file_count = x.file_count;
  }
}